












































import AbpBase from "@/lib/abpbase"; 
import {Component, Vue, Inject, Prop, Watch} from 'vue-property-decorator';
import {
    SaveGoodClinicalPracticeInspect
} from "@/api/hd";
import util from '@/lib/util'

@Component({})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;
    form:any = {}
    created() {
        console.log(this.data)
        if(this.data.title=='编辑'){
            this.form = Object.assign({},this.data.row)
            this.form.analysisDate = this.formatDateTime(this.form.analysisDate)
            console.log(this.form)
        }
    }
    rules = {
        title:[{required: true,message:this.L('FieldIsRequired'),trigger: 'blur'}],
    }
    cancel(){
        (this.$refs.form as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    async save(){
        (this.$refs.form as any).validate(async (valid:boolean)=>{
            if(valid){
                this.form.analysisDate = this.formatDateTime(this.form.analysisDate)
                this.form.gcptId = this.data.info.id;
                let res = await SaveGoodClinicalPracticeInspect(this.form)
                if(res.status==1){
                    this.$emit('input',false);
                    this.$emit('on-success')
                }
            }
        })
        
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/gcpManage/parts/gcpPractice/inspect.vue